<template>
  <div class="line_chart_wrap">
    <div class="chart_title mt-5" v-if="Boolean(chartData.title)">
      <div class="text-h6"><v-icon>mdi-circle-small</v-icon>{{ $i18n.translate(chartData.title) }}</div>
    </div>
    <Bar
        :chart-options="chartOptions"
        :chart-data="chartData"
        :chart-id="chartId"
        :dataset-id-key="datasetIdKey"
        :plugins="plugins"
        :css-classes="cssClasses"
        :styles="styles"
        :height="height"
    />
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import { Chart , Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
import  ChartDataLabels from 'chartjs-plugin-datalabels';
import UT from "@/common/util";

Chart.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ChartDataLabels)
export default {
  name: 'StackChart',
  components: { Bar },
  props: {
    chartData:{
      type: Object,
      default: () => {}
    },
    chartId: {
      type: String,
      default: 'bar-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 100
    },
    cssClasses: {
      default: '',
      type: String
    },
    plugins: {
      type: Object,
      default: () => {}
    }

  },
  computed: {
    styles () {
      return {
        height: `${this.height}px`,
      }
    },
    computeSummary() {
      if (!this.chartData.summary) {
        return null;
      }
      return {
        myTotal: this.chartData.summary.total,
        myDone: this.chartData.summary.done,
      }
    },
    computeMyAvg() {
      let s = this.computeSummary;
      return s.myTotal === 0 ? 0 : UT.toFixed(s.myDone / s.myTotal * 100, 2);
    },
    displayMyTotal() {
      return `${this.$i18n.translate('내 참여율')} : ${this.computeMyAvg}%`;
    },
    displayStatus() {
      if (!this.computeSummary.myTotal) {
        return "smile";
      }
      return this.computeMyAvg > 50 ? "smile" : "crying";
    },
    displayTotalAvg() {
      if (!this.chartData) {
        return null;
      }
      let list = [];
      this.chartData.labels.forEach((row, i) => {
        let done = this.chartData.datasets[0].data[i];
        let todo = this.chartData.datasets[1].data[i];
        let total = done + todo;
        list.push({
          label: row,
          rate: total === 0 ? 0 : UT.toFixed(done / total * 100, 2)
        });
      });
      return list;
    }
  },
  data() {
    let unitY = this.chartData.unitY || '';
    let maxY = this.chartData.maxY;
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'x',
        scales: {
          y: {
            beginAtZero: true,
            max: maxY,
            ticks: {
              callback: function(value) {  //축 뒤에 % 표시 포맷
                return `${value}${unitY}`;
              }
            }
          }
        },
        layout: {
          padding: 0
        },
        plugins: {
          legend: {
            display: false,
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
          },
        },
      }
     }
  }
}
</script>


<style scoped>

</style>
